const ToothBrush = () => {
	return (
		<>
			<path
				d="M2.1698 3.41645L5.01525 0.580519C5.2151 0.380672 5.54818 0.380672 5.74803 0.580519L6.75678 1.58927C6.95663 1.78912 6.95663 2.1222 6.75678 2.32205L3.92085 5.15798"
				fill="white"
			/>
			<path
				d="M4.22535 5.4625L3.62581 4.86296L6.46174 2.02703V1.89379L5.45299 0.885039C5.41492 0.846972 5.35782 0.846972 5.31976 0.885039L2.48382 3.72097L1.88428 3.12143L4.7107 0.275979C5.08184 -0.0951668 5.68138 -0.0951668 6.05253 0.275979L7.06129 1.28473C7.2421 1.46555 7.33727 1.70346 7.33727 1.96041C7.33727 2.21736 7.2421 2.44575 7.06129 2.62657L4.22535 5.4625Z"
				fill="#002855"
			/>
			<path
				d="M3.88281 5.12944L6.72826 2.2935C6.92811 2.09365 7.26119 2.09365 7.46104 2.2935L8.46979 3.30226C8.66964 3.5021 8.66964 3.83518 8.46979 4.03503L5.63386 6.87097"
				fill="white"
			/>
			<path
				d="M5.92884 7.17549L5.32929 6.57595L8.16523 3.74001C8.16523 3.74001 8.20329 3.64485 8.16523 3.60678L7.15647 2.59803H7.02324L4.17779 5.43396L3.57825 4.83442L6.4237 1.99848C6.60451 1.81767 6.84243 1.7225 7.08986 1.7225C7.3468 1.7225 7.58472 1.81767 7.75602 1.99848L8.76477 3.00724C9.13592 3.37838 9.13592 3.97793 8.76477 4.34907L5.92884 7.18501V7.17549Z"
				fill="#002855"
			/>
			<path
				d="M5.62427 6.87095L8.46972 4.03502C8.66957 3.83517 9.00265 3.83517 9.20249 4.03502L10.2112 5.04377C10.4111 5.24362 10.4111 5.5767 10.2112 5.77655L7.37531 8.61248"
				fill="white"
			/>
			<path
				d="M7.67981 8.91701L7.08027 8.31746L9.91621 5.48153C9.91621 5.48153 9.95427 5.38636 9.91621 5.3483L8.90745 4.33954H8.77422L5.92877 7.17548L5.32922 6.57593L8.17467 3.74C8.35549 3.55919 8.5934 3.46402 8.84083 3.46402C9.09778 3.46402 9.33569 3.55919 9.50699 3.74L10.5157 4.74875C10.8869 5.1199 10.8869 5.71944 10.5157 6.09059L7.67981 8.92652V8.91701Z"
				fill="#002855"
			/>
			<path
				d="M7.37537 8.62202L10.2208 5.78609C10.4207 5.58624 10.7537 5.58624 10.9536 5.78609L11.9623 6.79484C12.1622 6.99469 12.1622 7.32777 11.9623 7.52762L9.12641 10.3636"
				fill="white"
			/>
			<path
				d="M9.42139 10.6586L8.82185 10.059L11.6578 7.22308C11.6578 7.22308 11.6958 7.12791 11.6578 7.08984L10.649 6.08109C10.649 6.08109 10.5539 6.04302 10.5158 6.08109L7.67034 8.91702L7.0708 8.31748L9.91625 5.48155C10.2874 5.1104 10.8869 5.1104 11.2581 5.48155L12.2668 6.4903C12.638 6.86145 12.638 7.46099 12.2668 7.83213L9.43091 10.6681L9.42139 10.6586Z"
				fill="#002855"
			/>
			<path
				d="M21.2219 21.85L11.9052 12.5238L9.05974 10.3065L2.55042 3.79713C2.11266 3.35937 1.3894 3.35937 0.942119 3.79713L0.761305 3.97795C0.323543 4.41571 0.323543 5.13897 0.761305 5.58625L7.27063 12.0956L9.50702 14.922L18.8237 24.2482C19.2615 24.686 19.9752 24.686 20.4225 24.2482L21.2219 23.4488C21.6597 23.0111 21.6597 22.2973 21.2219 21.85Z"
				fill="#B9DEFA"
			/>
			<path
				d="M19.6231 25C19.2044 25 18.8142 24.8382 18.5192 24.5432L9.20251 15.217L6.92806 12.362L0.456795 5.88125C-0.152265 5.27219 -0.152265 4.28247 0.456795 3.67341L0.637609 3.49259C1.24667 2.88353 2.23639 2.88353 2.84545 3.49259L9.35478 10.0019L12.1622 12.1812L21.5265 21.5455C21.8215 21.8405 21.9833 22.2307 21.9833 22.6494C21.9833 23.0682 21.8215 23.4583 21.5265 23.7438L20.7271 24.5432C20.4321 24.8382 20.0419 25 19.6327 25H19.6231ZM1.74153 3.88277C1.56072 3.88277 1.3799 3.94939 1.23715 4.09214L1.05634 4.27295C0.780358 4.54893 0.780358 4.99621 1.05634 5.27219L7.56566 11.7815L9.84012 14.6365L19.1283 23.9246C19.2615 24.0579 19.4328 24.134 19.6231 24.134C19.8135 24.134 19.9848 24.0579 20.118 23.9246L20.9174 23.1253C21.0506 22.992 21.1268 22.8112 21.1268 22.6304C21.1268 22.4496 21.0506 22.2688 20.9174 22.1355L11.6007 12.8093L8.7933 10.63L2.24591 4.09214C2.10316 3.94939 1.92235 3.88277 1.74153 3.88277Z"
				fill="#002855"
			/>
		</>
	);
};

export default ToothBrush;
